import React, { createContext, useEffect, useState } from "react";
import useAuth from "../hook/useAuth";
import useReservation from "../hook/useReservation";
import { jwtDecode } from "jwt-decode";
import useMessages from "../hook/useMessages";
import useReservationSettings from "../hook/useReservationSettings";
import useHolidays from "../hook/useHolidays";
import usePromotions from "../hook/usePromotions";
import useContents from "../hook/useContents";
import useEvents from "../hook/useEvents";
import useMenus from "../hook/useMenus";
import useDiningTables from "../hook/useDiningTables";

export const AppContext = createContext();

export const AppContextProvider = (props) => {
  const [adminToken, setAdminToken] = useState(null);
  const [tokenData, setTokenData] = useState(null);

  const { authLoading, userLogin, fetchShopSettings } = useAuth();

  const {
    fetchNewReservations,
    todaysReservationList,
    fetchReservationHistory,
    fetchFutureReservations,
    addNewReservartion,
    reservationLoading,
    recentEnquiries,
    todayEnquiries,
    upcomingEnquiries,
    enquiriesHistory,
    fetchReservationById,
    updateEnquiry,
    enquiryActionLoading,
    tokenError,
    setTokenError,
    upcomingwithtodaysReservationList,
    upcomingwithTodays,
    fetchAllTables,
    tableLists,
    fetchAvailableTables,
    deleteReservation,
    getReservationTiming,
    reservFoodpageTiming,
    getActiveColure,
    closuresAllHistory,
    createNewClosure,
    removeClosure,
    closureList,
    closuresHistory,
    alterReservationTiming,
  } = useReservation();

  const {
    fetchCurrentSettings,
    reservSettingsLoading,
    reservationSettings,
    createNewReservations,
    updateReservationSettings,
    getSettings,
    foodpageReservSettings,
    reservationStatus,
    setReservationStatus,
    updateSettings,
    settingsReservationTiming,
    settingsShopTiming,
    settingsClosureList,
  } = useReservationSettings();

  // Prefer timings / closures from settings API; fall back to legacy endpoints
  const activeReservationTiming =
    settingsReservationTiming &&
    typeof settingsReservationTiming === "object" &&
    Object.keys(settingsReservationTiming).length > 0
      ? settingsReservationTiming
      : reservFoodpageTiming;

  const activeClosureList = Array.isArray(settingsClosureList)
    ? settingsClosureList
    : closureList;

  const {
    getAllholidays,
    holidaysList,
    getUpcomingHolidaysList,
    upComingHolidays,
    holidaysLoading,
    removeHolidaySingle,
    createNewHoliday,
  } = useHolidays();

  const {
    promotion,
    promotionLoading,
    getPromotions,
    newPromotions,
    deletePromotion,
    updatePromotion,
    changePromotionStatus,
  } = usePromotions();

  const { sendNewMessage, getMessages, messageLoading } = useMessages();

  const {
    fetchAllContentsData,
    contentsList,
    contentLoading,
    sortedContents,
    fetchAllContentsDataNew,
    updateContent,
    createContent,
  } = useContents();

  const {
    eventsList,
    eventsLoading,
    getEvents,
    createNewEvents,
    updateSingleEvent,
  } = useEvents();

  const { menuItems, menuLoading, fetchMenuItems } = useMenus();

  const {
    diningTables,
    diningTablesLoading,
    fetchDiningTables,
    createDiningTable,
    updateDiningTable,
    updateDiningTableStatus,
  } = useDiningTables();

  useEffect(() => {
    fetchTokenData();
    fetchCurrentSettings();
  }, []);

  const fetchTokenData = () => {
    const token = window.localStorage.getItem("UserRetention");

    if (!token) return;

    const userValue = jwtDecode(token);

    if (userValue && userValue.length != 0) {
      setTokenData(userValue);
    }
  };

  useEffect(() => {
    const token = window.localStorage.getItem("UserRetention");

    if ((!token || token.length === 0) && tokenError != null) {
      setTokenError({ Status: "Token expired", error: true });
      return;
    }

    if (!token || tokenError) return;

    const shopToken = window.localStorage.getItem("shopCustomToken");

    getAllholidays(token);
    getUpcomingHolidaysList(token);
    getPromotions(token);
    fetchAllContentsData();
    fetchAllContentsDataNew();
    getEvents(token);
    fetchMenuItems(token);

    if (shopToken && shopToken.length != 0) {
      upcomingwithtodaysReservationList();
      fetchAllTables();
      getSettings();
      closuresAllHistory();
    }

    if (tokenData && tokenData.shopCustomToken) {
      const customToken = tokenData.shopCustomToken;

      fetchNewReservations(customToken);
      todaysReservationList(customToken);
      fetchReservationHistory(customToken);
      fetchFutureReservations(customToken);
    } else if (!tokenData) {
      fetchTokenData();
    }
  }, [tokenError, tokenData]);

  return (
    <AppContext.Provider
      value={{
        authLoading,
        userLogin,
        setAdminToken,
        adminToken,
        tokenData,
        fetchNewReservations,
        fetchShopSettings,
        todaysReservationList,
        fetchReservationHistory,
        fetchFutureReservations,
        addNewReservartion,
        reservationLoading,
        recentEnquiries,
        todayEnquiries,
        upcomingEnquiries,
        enquiriesHistory,
        fetchReservationById,
        updateEnquiry,
        enquiryActionLoading,
        sendNewMessage,
        getMessages,
        messageLoading,
        fetchCurrentSettings,
        reservSettingsLoading,
        reservationSettings,
        createNewReservations,
        newPromotions,
        tokenError,
        setTokenError,
        updateReservationSettings,
        getAllholidays,
        holidaysList,
        getUpcomingHolidaysList,
        upComingHolidays,
        holidaysLoading,
        removeHolidaySingle,
        createNewHoliday,
        promotion,
        promotionLoading,
        getPromotions,
        deletePromotion,
        updatePromotion,
        changePromotionStatus,
        fetchAllContentsData,
        contentsList,
        contentLoading,
        sortedContents,
        fetchAllContentsDataNew,
        updateContent,
        createContent,
        eventsList,
        eventsLoading,
        getEvents,
        createNewEvents,
        updateSingleEvent,
        menuItems,
        menuLoading,
        fetchMenuItems,
        upcomingwithtodaysReservationList,
        upcomingwithTodays,
        fetchAllTables,
        tableLists,
        fetchAvailableTables,
        deleteReservation,
        getReservationTiming,
        reservFoodpageTiming: activeReservationTiming,
        settingsReservationTiming,
        settingsShopTiming,
        getSettings,
        foodpageReservSettings,
        getActiveColure,
        closuresAllHistory,
        createNewClosure,
        removeClosure,
        closureList: activeClosureList,
        closuresHistory,
        reservationStatus,
        setReservationStatus,
        updateSettings,
        alterReservationTiming,
        diningTables,
        diningTablesLoading,
        fetchDiningTables,
        createDiningTable,
        updateDiningTable,
        updateDiningTableStatus,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
